/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Rate
 */
import { Resource } from '@/modules/backend/Entities/Resource';
import { Type } from 'class-transformer';
import { Building } from './Building';
import { Account } from '@/modules/backend/Entities/Account';

export class Rate {
  public readonly removable!: boolean;

  private readonly id!: number;

  @Type(() => Resource)
  private readonly resource!: Resource;

  @Type(() => Building)
  private readonly building?: Building;

  @Type(() => Account)
  private readonly account?: Account;

  private readonly price!: number;

  public getId(): number {
    return this.id;
  }

  public getResource(): Resource {
    return this.resource;
  }

  public getBuilding(): Building | undefined {
    return this.building || undefined;
  }

  public getPrice(): number {
    return Number(this.price);
  }

  public getAccount(): Account | undefined {
    return this.account || undefined;
  }
}
